import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { toast } from "react-toastify"
import api, { timeout } from "../../api"
import { setMessage } from "../message/messageSlice"

export const getGovtAdminBudgetDashboard = createAsyncThunk(
  "dashboard/getGovtAdminBudgetDashboard",
  async ({ budgetId, year }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/main/budget/analytics`,
        { params: { budget: budgetId, year } }
      )
      return response?.data
    } catch (error) {
      let message = "Failed to fetch budget information"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getPerformanceDashboard = createAsyncThunk(
  "dashboard/getPerformanceDashboard",
  async ({ year, mda }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/feature/performances`, {
        params: { year, mda },
      })
      return response?.data
    } catch (error) {
      let message = "Failed to fetch work plan information"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getExecutiveDashboard = createAsyncThunk(
  "dashboard/getExecutiveDashboard",
  async ({ year, mda }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/feature/executive`, {
        params: { year, mda },
      })
      return response?.data
    } catch (error) {
      let message = "Failed to fetch work plan information"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getAllMDAsPerformance = createAsyncThunk(
  "dashboard/getAllMDAsPerformance",
  async ({ quarter, year }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/feature/performance/sheets`, {
        params: { quarter, year },
      })
      return response?.data
    } catch (error) {
      let message = "Failed to fetch work plan information"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getGovtAdminWorkplanDashboard = createAsyncThunk(
  "dashboard/getGovtAdminWorkplanDashboard",
  async ({ budgetId, year }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/dashboard`, {
        params: { budget: budgetId, year },
      })
      return response?.data
    } catch (error) {
      let message = "Failed to fetch work plan information"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getProjectDistirbution = createAsyncThunk(
  "dashboard/getProjectDistirbution",
  async ({ mda, year }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/feature/spread`, {
        params: { mda, year },
      })
      return response?.data
    } catch (error) {
      let message = "Failed to fetch project distribution"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getProjectDistirbutionDetails = createAsyncThunk(
  "dashboard/getProjectDistirbutionDetails",
  async ({ lg, mda, year }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/feature/lg/activities`, {
        params: { lg, mda, year },
      })
      return response.data
    } catch (err) {
      let message = "Failed to fetch project distribution information"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getMDAProjectDistirbution = createAsyncThunk(
  "dashboard/getMDAProjectDistirbution",
  async ({ year }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/wp/feature/mda/spread?year=${year}`
      )
      return response?.data
    } catch (error) {
      let message = "Failed to fetch project distribution"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getExecutiveDashboardSummary = createAsyncThunk(
  "dashboard/getExecutiveDashboardSummary",
  async ({ budgetId, year }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/sharepoint/summary?budget=${budgetId}&year=${year}`
      )
      return response?.data
    } catch (error) {
      let message = "Failed to fetch dashboard information"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getGovtSupportDashboardSummary = createAsyncThunk(
  "dashboard/getGovtSupportDashboardSummary",
  async ({ year }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/summary?year=${year}`)
      return response?.data
    } catch (error) {
      let message = "Failed to fetch dashboard information"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getGovtExecutiveDashboardSummary = createAsyncThunk(
  "dashboard/getGovtExecutiveDashboardSummary",
  async ({ year }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/wp/activities/summary?year=${year}`
      )
      return response?.data
    } catch (error) {
      let message = "Failed to fetch dashboard information"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getExecutiveSummaryWorkplanDetails = createAsyncThunk(
  "dashboard/getExecutiveSummaryWorkplanDetails",
  async ({ wp }, { rejectWithValue }) => {
    try {
      const response = await api.get(`/abide/v2/wp/mda/activities?wp=${wp}`)
      return response?.data
    } catch (error) {
      let message = "Failed to fetch work plan details"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getlivefeed = createAsyncThunk(
  "dashboard/getlivefeed",
  async ({ budgetId }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v1/dashboards/feeds?budget=${budgetId}`
      )
      return response?.data
    } catch (error) {
      let message = "Failed to fetch live feed"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
export const getMDAlivefeed = createAsyncThunk(
  "dashboard/getMDAlivefeed",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/dashboards/mda/feeds`)
      return response?.data
    } catch (error) {
      let message = "Failed to fetch live feed"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
//MDA DASHBOARD
export const getMDADashboard = createAsyncThunk(
  "dashboard/getMDADashboard",
  async ({ budgetId }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/mda/budget/analytics?budget=${budgetId}`
      )
      return response?.data
    } catch (error) {
      let message = "Failed to fetch dashboard"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)
//OPERATOR DASHBOARD
export const getoperatordashboard = createAsyncThunk(
  "dashboard/getoperatordashboard",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/payments/v1/dashboard/government/user`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))

      return rejectWithValue(message)
    }
  }
)

export const getoperatorcollections = createAsyncThunk(
  "dashboard/getoperatorcollections",
  async (
    { search, start, end, cursor, navigation, pagesize },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await api.get(
        `abide/payments/v1/collections/self?search=${search}&start=${start}&end=${end}&cursor=${cursor}&navigation=${navigation}&page-size=${pagesize}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))

      return rejectWithValue(newMessage)
    }
  }
)
//AGENCY OPERATION DASHBOARD
export const getagencydashboard = createAsyncThunk(
  "dashboard/getagencydashboard",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/payments/v1/dashboard/government/mda`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))

      return rejectWithValue(newMessage)
    }
  }
)

export const getagencytransactionfeed = createAsyncThunk(
  "dashboard/getagencytransactionfeed",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/payments/v1/dashboard/government/mda-feed`
      )
      return response?.data
    } catch (error) {
      let message = "Failed to fetch agency transaction feed"
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        message = err.response.data.message
      }
      return rejectWithValue(message)
    }
  }
)

const initialState = {
  data: null,
  details: null,
  loading: false,
  personal: null,
  feed: null,
  operatorsFeed: null,
  distributions: null,
  distribution: null,
  MDAdistributions: null,
  isloading: false,
  MDAperformances: null,
  performance: null,
  executive: null,
}

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getGovtAdminBudgetDashboard.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(
      getGovtAdminBudgetDashboard.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.data = payload.data
      }
    )
    builder.addCase(getGovtAdminBudgetDashboard.rejected, (state) => {
      state.data = null
      state.loading = false
    })
    builder.addCase(getGovtAdminWorkplanDashboard.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(
      getGovtAdminWorkplanDashboard.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.data = payload.data
      }
    )
    builder.addCase(getGovtAdminWorkplanDashboard.rejected, (state) => {
      state.data = null
      state.loading = false
    })
    //Performance Dashboard
    builder.addCase(getPerformanceDashboard.pending, (state) => {
      state.loading = true
      state.performance = null
    })
    builder.addCase(getPerformanceDashboard.fulfilled, (state, { payload }) => {
      state.loading = false
      state.performance = payload.data
    })
    builder.addCase(getPerformanceDashboard.rejected, (state) => {
      state.loading = false
      state.performance = false
    })
    //Get Exective Dashboard
    builder.addCase(getExecutiveDashboard.pending, (state) => {
      state.loading = true
      state.executive = null
    })
    builder.addCase(getExecutiveDashboard.fulfilled, (state, { payload }) => {
      state.loading = false
      state.executive = payload.data
    })
    builder.addCase(getExecutiveDashboard.rejected, (state) => {
      state.loading = false
      state.executive = false
    })
    //MDA Performance
    builder.addCase(getAllMDAsPerformance.pending, (state) => {
      state.loading = true
      state.MDAperformances = null
    })
    builder.addCase(getAllMDAsPerformance.fulfilled, (state, { payload }) => {
      state.loading = false
      state.MDAperformances = payload.data
    })
    builder.addCase(getAllMDAsPerformance.rejected, (state) => {
      state.loading = false
      state.MDAperformances = false
    })

    //DISTRIBUTION
    builder.addCase(getProjectDistirbution.pending, (state) => {
      state.loading = true
      state.distributions = null
    })
    builder.addCase(getProjectDistirbution.fulfilled, (state, { payload }) => {
      state.loading = false
      state.distributions = payload.data
    })
    builder.addCase(getProjectDistirbution.rejected, (state) => {
      state.distributions = null
      state.loading = false
    })
    //DISTRIBUTION DETAILS

    builder.addCase(getProjectDistirbutionDetails.pending, (state) => {
      state.loading = true
      state.distribution = null
    })
    builder.addCase(
      getProjectDistirbutionDetails.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.distribution = payload.data
      }
    )
    builder.addCase(getProjectDistirbutionDetails.rejected, (state) => {
      state.distribution = null
      state.loading = false
    })
    builder.addCase(getMDAProjectDistirbution.pending, (state) => {
      state.loading = true
      state.MDAdistributions = null
    })
    builder.addCase(
      getMDAProjectDistirbution.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.MDAdistributions = payload.data
      }
    )
    builder.addCase(getMDAProjectDistirbution.rejected, (state) => {
      state.MDAdistributions = null
      state.loading = false
    })
    builder.addCase(getExecutiveDashboardSummary.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(
      getExecutiveDashboardSummary.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.data = payload.data
      }
    )
    builder.addCase(getExecutiveDashboardSummary.rejected, (state) => {
      state.data = null
      state.loading = false
    })
    //SUPPORT
    builder.addCase(getGovtSupportDashboardSummary.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(
      getGovtSupportDashboardSummary.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.data = payload.data
      }
    )
    builder.addCase(getGovtSupportDashboardSummary.rejected, (state) => {
      state.data = null
      state.loading = false
    })
    //getGovtExecutiveDashboardSummary
    builder.addCase(getGovtExecutiveDashboardSummary.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(
      getGovtExecutiveDashboardSummary.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.data = payload.data
      }
    )
    builder.addCase(getGovtExecutiveDashboardSummary.rejected, (state) => {
      state.data = null
      state.loading = false
    })
    //getExecutiveSummaryWorkplanDetails
    builder.addCase(getExecutiveSummaryWorkplanDetails.pending, (state) => {
      state.loading = true
      state.details = null
    })
    builder.addCase(
      getExecutiveSummaryWorkplanDetails.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.details = payload.data
      }
    )
    builder.addCase(getExecutiveSummaryWorkplanDetails.rejected, (state) => {
      state.details = null
      state.loading = false
    })

    builder.addCase(getlivefeed.fulfilled, (state, { payload }) => {
      state.feed = payload.data
    })
    builder.addCase(getMDAlivefeed.fulfilled, (state, { payload }) => {
      state.feed = payload.data
    })
    //MDA DASHBOARD
    builder.addCase(getMDADashboard.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(getMDADashboard.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(getMDADashboard.rejected, (state) => {
      state.data = null
      state.loading = false
    })
    //OPERATOR DASHBOARDE
    builder.addCase(getoperatordashboard.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(getoperatordashboard.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(getoperatordashboard.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    builder.addCase(getoperatorcollections.pending, (state) => {
      state.isloading = true
      state.collections = null
    })
    builder.addCase(getoperatorcollections.fulfilled, (state, { payload }) => {
      state.isloading = false
      state.collections = payload.data
    })
    builder.addCase(getoperatorcollections.rejected, (state) => {
      state.loading = false
      state.collections = null
    })
    //AGENCY DASHBOARD COLLECTIONS
    builder.addCase(getagencydashboard.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(getagencydashboard.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(getagencydashboard.rejected, (state) => {
      state.data = null
      state.loading = false
    })
    //AGENCY DASHBOARD COLLECTIONS
    builder.addCase(
      getagencytransactionfeed.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.feed = payload.data
      }
    )
  },
})

export default dashboardSlice.reducer
